<template>
  <div class="page-container">
    <div class="page-header">
      <HeaderCom></HeaderCom>
    </div>
    <div class="scene-main">
      <scene-component @changeData="changeData"></scene-component>
    </div>
    <div class="meeting-main">
      <meeting-minutes ref="meeting" :updateData="taskData"></meeting-minutes>
    </div>
  </div>
</template>

<script>
import HeaderCom from "./../../components/headerCom";
import sceneComponent from "./officeScene";
import meetingMinutes from "./meetingMinutes";
export default {
  components: {
    sceneComponent,
    meetingMinutes,
    HeaderCom,
  },
  name: "SimulationIndex",
  data() {
    return {
      taskData: [],
    };
  },
  methods: {
    changeData() {
      this.$refs["meeting"].updateTaskStatus();
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100vw;
  min-height: 100vh;
  background: url("./../../assets/image/simulation/bg.jpg");
  background-size: cover;
  padding-top: 60px;
  .page-header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 60px;
    background: #005be7;
    padding: 0 20px;
  }
  .scene-main {
    width: 900px;
    margin-right: 20px;
  }
  .meeting-main {
  }
}
</style>
